import { Link } from 'react-router-dom';
import { Search, BookOpen, Upload } from 'lucide-react';

interface EmptyStateProps {
  type: 'no-books' | 'no-results';
  searchQuery?: string;
  onClearSearch?: () => void;
}

export function EmptyState({ type, searchQuery, onClearSearch }: EmptyStateProps) {
  if (type === 'no-results') {
    return (
      <div className="empty-state">
        <Search className="empty-state-icon" aria-hidden="true" />
        <h2>No books found</h2>
        <p>
          We couldn't find any books matching "<strong>{searchQuery}</strong>".
          Try a different search term or check your spelling.
        </p>
        <button type="button" onClick={onClearSearch} className="btn btn-primary">
          Clear search
        </button>
      </div>
    );
  }

  return (
    <div className="empty-state">
      <BookOpen className="empty-state-icon" aria-hidden="true" />
      <h2>Your library is empty</h2>
      <p>Upload your first book to start building your personal library.</p>
      <Link to="/upload" className="btn btn-primary">
        <Upload className="icon icon-sm" aria-hidden="true" />
        Upload Book
      </Link>
    </div>
  );
}
